<div fxLayout="column" fxLayoutGap="32px" class="properties-container">
  <div class="info-container" *ngIf="loading">
    <section>
      <div class="connection-pending-header">
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center">
          <img src="/assets/images/hospitable.png" alt="Hospitable Logo" class="logo hospitable-logo" />
          <img src="/assets/iconography/connect.svg" class="connect-img" />
          <img src="/assets/images/connected-accounts/booking.svg" alt="Booking.com Logo" class="logo bdc-logo" />
        </div>
        <p class="header-description">This might take a few moments...</p>
      </div>

      <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="40px">
        <mat-spinner diameter="80"></mat-spinner>

        <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
          <strong class="larger-description">Do not close this screen.</strong>
          <span class="larger-description">We are waiting to receive data from Booking.com</span>
        </div>
      </div>
    </section>
  </div>

  <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="32px" *ngIf="!loading">
    <h2>Review properties</h2>

    <section fxLayout="column" fxLayoutGap="20px" class="full-width" *ngIf="unmatchedPropertyIds.length > 0">
      <sbnb-note [type]="NoteType.Info" [content]="'Accommodation IDs not found in Booking.com'">
        <span class="note-banner__slot">
          <p>
            The following accommodation IDs couldn't be found as having a pending connection request with Hospitable in
            Booking.com:
            <strong>{{ unmatchedPropertyIds.join(', ') }}</strong>
          </p>
          <p>
            Please ensure that the accommodation IDs are correct and a connection request to Hospitable has been
            initiated in Booking.com.
          </p>
        </span>

        <span class="note-banner__slot" *ngIf="reloading">
          <p>
            We are still trying to connect these properties and will update this page once we find the pending
            connection.
          </p>
          <div fxLayout="column" fxLayoutAlign="start start">
            <mat-spinner diameter="40"></mat-spinner>
          </div>
        </span>
      </sbnb-note>
    </section>
  </div>

  <section fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="32px">
    <!-- <div fxLayout="column" fxLayoutAlign="center center" *ngIf="loading">
      <mat-spinner diameter="80"></mat-spinner>
    </div> -->

    <div class="properties-box" *ngIf="!loading">
      <div
        class="properties-box-header"
        fxLayout="column"
        fxLayout.gt-xs="row"
        fxLayoutAlign="start start"
        fxLayoutAlign.gt-xs="space-between center">
        <strong>
          {{ connectedProperties.length ? connectedProperties.length : 'No' }}
          {{ 'properties' | pluralize: connectedProperties.length }} connected.
        </strong>
      </div>

      <ng-container *ngFor="let property of properties">
        <div *ngIf="property.name" fxLayout="column" fxLayoutGap="4px" fxLayoutAlign="start start" class="full-width">
          <div class="full-width" style="align-self: flex-start">
            <span fxLayout.gt-xs="row" fxLayoutGap="8px" fxLayoutAlign.gt-xs="space-between center" class="full-width">
              <span fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
                <img
                  [src]="property.main_photo_url ? property.main_photo_url : '/assets/images/image-error.png'"
                  class="property__img"
                  fxHide.lt-sm
                  style="width: 36px; height: 36px" />
                <span fxLayout="column" fxLayoutAlign="start start">
                  <span>
                    <strong>{{ property.name }}</strong>
                  </span>
                  <span class="night text__small clamp">{{ property.address }}</span>
                </span>
              </span>
              <div>
                <span *ngIf="property.issues.length > 0" class="property-warning badge badge-danger">
                  <sbnb-icon icon="details" class="text-smoke-darker"></sbnb-icon>
                  <span>{{ property.issues[0].label }}</span>
                </span>

                <span *ngIf="property.issues.length == 0" class="property-warning badge badge-grass">
                  <sbnb-icon icon="check"></sbnb-icon>
                  <span *ngIf="property.already_connected">Already</span>
                  Connected
                </span>
              </div>
            </span>
          </div>
        </div>
      </ng-container>
    </div>

    <div
      *ngIf="!loading"
      fxLayout
      fxLayoutGap="18px"
      fxLayoutAlign="end center"
      fxLayout.lt-md="column"
      fxLayoutAlign.lt-md="center stretch">
      <sbnb-button label="Back" type="secondary" (click)="back()" *ngIf="!properties"></sbnb-button>
      <sbnb-button
        data-intercom-target="booking-com-property-ids-continue"
        [label]="connectedProperties.length ? 'Continue' : 'Finish'"
        [loading]="loading"
        (click)="progress()"></sbnb-button>
    </div>
  </section>
</div>
